/* eslint-disable no-param-reassign */

import Promise from 'bluebird';
import _ from 'underscore';

import { FilterAgent } from '@bingads-webui/filter-agent';
import { fromFilterEntityToLegacyFilter } from '@bingads-webui-campaign/filter-converter';
import { updateGridQuery } from '../query-util';

function propagateWaterfallFilterToLegacyGrids({
  filter,
  waterfallEvent,
  legacyGridName,
  legacyDeps: {
    config,
    stateManager,
    preferences,
  },
}) {
  const legacyWaterfall = filter && !_.isEmpty(filter.query) ?
    fromFilterEntityToLegacyFilter(filter) : null;
  const usePreferencesService = _.result(config.get('Permissions'), 'IsUsePreferencesServiceEnabled');

  // set stateManager for legacy grid that need waterfall filter value
  const setPromise = [];
  const data = {
    FilterExpressions: legacyWaterfall,
    Id: '',
    Name: `${legacyGridName}Filter`,
  };

  if (usePreferencesService === true) {
    const prefix = config.get('StateManagerKeyPrefix');
    const preferenceData = {
      Name: `${prefix}${legacyGridName}_quickfilter`,
      Data: data,
    };

    setPromise.push(preferences.setAtUserLevel(preferenceData));
  }

  setPromise.push(stateManager.setItem('permanent', `${legacyGridName}_quickfilter`, data));

  Promise.all(setPromise).then(() => {
    window.App.trigger(waterfallEvent);
  });
}

function showExceededSaveLimitError(i18n, filterConfig, tabView) {
  const errMsg = i18n.getString('Error_Campaign_API_FiltersExceedsMaxCount')
    .replace('{0}', filterConfig.maxSavedFilterLimit);
  tabView.alertHelper.showAlert(errMsg);
}

export function initializeFilterAgent({
  tabView,
  gridView,
  toolbar,
  legacyDeps,
  customFilterUIChangeListener,
  gridToolbarGroup,
  legacyGridName,
}) {
  const { filterConfig } = tabView;
  const { i18n } = filterConfig;
  const isLabelEnabled = _.isObject(filterConfig.entitySchema.properties.Labels);

  filterConfig.menu = _.defaults({
    customItems: isLabelEnabled ? [
      {
        type: 'dropdown-divider',
      },
      {
        text: i18n.getString('Filter_By_Label'),
        onClick: () => {
          tabView.filterAgent.showFilterEditor({
            Labels: {
              $containsall: undefined,
            },
          });
        },
      },
    ] : [],
  }, filterConfig.menu);

  tabView.filterAgent = new FilterAgent(_.extend(filterConfig, {
    toolbarView: toolbar,
    filterService: tabView.filterService,
  }));

  tabView.listenTo(tabView.filterAgent, 'filter-ui-change', (state) => {
    if (customFilterUIChangeListener) {
      customFilterUIChangeListener(state);
    } else {
      tabView.setState(_.extend(tabView.getState(), state));
      tabView.viewModel.showToolBar(state.showToolBar);

      // do the hide/show toolbar operation
      if (state.showToolBar && gridToolbarGroup) {
        gridToolbarGroup.showAllToolbars();
      } else if (!state.showToolBar && gridToolbarGroup) {
        gridToolbarGroup.hideAllToolbars();
      }
      if (state.showFilterBar) {
        tabView.setChild('filter-bar', tabView.filterAgent.getFilterBar());
      }
      if (state.showFilterEditor) {
        tabView.setChild('filter-editor', tabView.filterAgent.getFilterEditor());
      }
    }
    gridView.refresh();
  });

  // TODO: switch this to use filter service, so that we don't rely on the UI
  // elements of the FilterAgent to be ready before apply filter to the gridView
  tabView.listenTo(tabView.filterAgent, 'filter-state-changed', ({ filter, quickFilter }, subStatus) => {
    updateGridQuery(gridView, filter);

    if (subStatus === 'quick-filter-applied' && quickFilter && filterConfig.waterfallEvent) {
      propagateWaterfallFilterToLegacyGrids({
        filter: quickFilter,
        waterfallEvent: filterConfig.waterfallEvent,
        legacyGridName: legacyGridName || tabView.getChild('grid').grid.config.legacyGridName,
        legacyDeps,
      });
    }
  });

  tabView.listenTo(tabView.filterAgent, 'filter-operation-failed', (errorData) => {
    if (errorData.message === 'ExceededSaveLimit') {
      showExceededSaveLimitError(i18n, filterConfig, tabView);
    } else {
      tabView.alertHelper.showUnknownError();
    }
  });

  tabView.listenTo(tabView.filterAgent, 'filter-max-reached', () => {
    showExceededSaveLimitError(i18n, filterConfig, tabView);
  });
}
